"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * USCIS Verifications Identity Service
 * An [Oauth 2.0](https://tools.ietf.org/html/rfc6749) compliant API which wraps the [identity providers](https://maestro.dhs.gov/confluence/display/VERST/Identity+Providers) used in the USCIS Verifications ecosystem.
 *
 * The version of the OpenAPI document: 2.4.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrorCodeToJSON = exports.ValidationErrorCodeFromJSONTyped = exports.ValidationErrorCodeFromJSON = exports.ValidationErrorCode = void 0;
/**
 * Errors that may be returned when the user submits a /one-time-code:   * `OTC_EXPIRED` - Indicates that the code has already expired.   * `OTC_ALREADY_VERIFIED` - The code exists but has already been verified.   * `OTC_NOT_PRESENT` - The code does not exist in the database. Errors that may be returned when the user attempts to /login-user   * `USER_NOT_PRESENT` - The given user could not be found in the dashboard jwt\'s claims.   * `INVALID_TOKEN` - The bearer token is not of the appropriate type for this operation.
 * @export
 * @enum {string}
 */
var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode["OTCEXPIRED"] = "OTC_EXPIRED";
    ValidationErrorCode["OTCALREADYVERIFIED"] = "OTC_ALREADY_VERIFIED";
    ValidationErrorCode["OTCNOTPRESENT"] = "OTC_NOT_PRESENT";
    ValidationErrorCode["USERNOTPRESENT"] = "USER_NOT_PRESENT";
    ValidationErrorCode["INVALIDTOKEN"] = "INVALID_TOKEN";
})(ValidationErrorCode = exports.ValidationErrorCode || (exports.ValidationErrorCode = {}));
function ValidationErrorCodeFromJSON(json) {
    return ValidationErrorCodeFromJSONTyped(json, false);
}
exports.ValidationErrorCodeFromJSON = ValidationErrorCodeFromJSON;
function ValidationErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ValidationErrorCodeFromJSONTyped = ValidationErrorCodeFromJSONTyped;
function ValidationErrorCodeToJSON(value) {
    return value;
}
exports.ValidationErrorCodeToJSON = ValidationErrorCodeToJSON;
